"use client";

import { QueryKeys } from "@/data/globals";
import { getEventsAction } from "@/actions/rangers/eventActions";
import { useQuery } from "@tanstack/react-query";

export function useEvents() {
  const { data, isLoading } = useQuery({
    queryKey: [QueryKeys.RANGER_EVENTS],
    queryFn: async () => await getEventsAction()
  });

  return { data, isLoading };
}
